import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletEmptyInbox = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 177,
	height: 72.75,
	viewBox: "0 0 177 72.75",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "The inbox is empty / Responsive",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Background",
				d: "M97.5137 8.93182C100.682 8.93182 103.25 11.4963 103.25 14.6594C103.25 17.8223 100.682 20.3859 97.5137 20.3859H149.958C153.126 20.3859 155.694 22.9505 155.694 26.1135C155.694 29.2765 153.126 31.841 149.958 31.841H167.986C171.154 31.8412 173.722 34.4056 173.722 37.5685C173.721 40.7313 171.154 43.2949 167.986 43.2951H152.417C149.249 43.2951 146.681 45.8596 146.681 49.0226C146.681 52.1857 149.249 54.7502 152.417 54.7502H157.333C160.501 54.7502 163.069 57.3146 163.069 60.4777C163.069 63.6406 160.501 66.2043 157.333 66.2043H114.722C114.3 66.2042 113.889 66.1587 113.493 66.0724C113.097 66.1588 112.686 66.2043 112.264 66.2043H37.6943C34.5266 66.2042 31.9583 63.6406 31.958 60.4777C31.958 57.3147 34.5264 54.7502 37.6943 54.7502H5.73633C2.56836 54.7502 0 52.1857 0 49.0226C4.47475e-05 45.8596 2.56839 43.2951 5.73633 43.2951H38.5137C41.6815 43.2951 44.2498 40.7315 44.25 37.5685C44.25 34.4054 41.6816 31.841 38.5137 31.841H18.0273C14.8596 31.8408 12.292 29.2764 12.292 26.1135C12.2921 22.9506 14.8596 20.3861 18.0273 20.3859H50.8057C47.6378 20.3859 45.0695 17.8223 45.0693 14.6594C45.0693 11.4963 47.6377 8.93182 50.8057 8.93182H97.5137ZM171.264 54.7502C174.432 54.7502 177 57.3146 177 60.4777C177 63.6406 174.431 66.2043 171.264 66.2043C168.096 66.2042 165.528 63.6406 165.527 60.4777C165.527 57.3147 168.096 54.7502 171.264 54.7502Z",
				fill: "#F4F4F4"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M78.7638 48.4551C78.6997 48.9077 78.6666 49.3703 78.6666 49.8406C78.6666 55.263 83.0691 59.6587 88.4999 59.6587C93.9307 59.6587 98.3333 55.263 98.3333 49.8406C98.3333 49.3703 98.3002 48.9077 98.2361 48.4551H122.097V70.2951C122.097 71.6507 120.997 72.7497 119.639 72.7497H57.3611C56.0034 72.7497 54.9027 71.6507 54.9027 70.2951V48.4551H78.7638Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M99.1527 48.2045C99.1527 54.0788 94.3833 58.8409 88.4999 58.8409C82.6166 58.8409 77.8472 54.0788 77.8472 48.2045C77.8472 48.0142 77.8522 47.8251 77.8621 47.6372H54.9027L62.737 24.5091C63.0747 23.512 64.0116 22.8409 65.0657 22.8409H111.934C112.988 22.8409 113.925 23.512 114.263 24.5091L122.097 47.6372H99.1378C99.1477 47.8251 99.1527 48.0142 99.1527 48.2045Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_3",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M97.5938 48.9851C97.5938 53.5243 93.5223 58.0223 88.4999 58.0223C83.4776 58.0223 79.4061 53.5243 79.4061 48.9851C79.4061 48.838 79.4104 47.8737 79.4188 47.7285H62.2777L68.9655 31.4931C69.2538 30.7227 70.0536 30.2041 70.9535 30.2041H106.046C106.946 30.2041 107.746 30.7227 108.034 31.4931L114.722 47.7285H97.5811C97.5895 47.8737 97.5938 48.838 97.5938 48.9851Z",
				fill: "#EBEBEB"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M55.927 47.8051V69.4769C55.927 70.2677 56.5691 70.9087 57.3611 70.9087H119.639C120.431 70.9087 121.073 70.2677 121.073 69.4769V47.8051L113.293 24.8364C113.096 24.2547 112.549 23.8633 111.934 23.8633H65.0657C64.4508 23.8633 63.9043 24.2547 63.7073 24.8364L55.927 47.8051Z",
				stroke: "#A0A0A0",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape",
				d: "M66.375 47.3867C69.6008 47.3867 73.082 47.3867 76.8187 47.3867C78.3562 47.3867 78.3562 48.4656 78.3562 49.0231C78.3562 54.4455 82.86 58.8413 88.4158 58.8413C93.9715 58.8413 98.4753 54.4455 98.4753 49.0231C98.4753 48.4656 98.4753 47.3867 100.013 47.3867H120.458M60.2896 47.3867H62.2777H60.2896Z",
				stroke: "#A0A0A0",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "lines",
				d: "M109.068 4.27042L99.9721 14.4593M87.7621 0.75V14.4593V0.75ZM66.3749 4.27042L75.4705 14.4593L66.3749 4.27042Z",
				stroke: "#7548F0",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgWalletEmptyInbox;
